import { useEffect, useState } from 'react';
import { hasMarketingConsent, onMarketingConsent } from './CookieConsentHelper.ts';

export const useMarketingConsent = (): boolean => {
  const [consented, setConsented] = useState(hasMarketingConsent);

  useEffect(() => onMarketingConsent(() => setConsented(true)), []);

  return consented;
};
